// extracted by mini-css-extract-plugin
export default {"container":"fHj8G","schemes":"hAmZK","placeholder":"o43dx","schemeCell":"XEFLg","schemeImgWrapper":"SA83J","schemeImg":"MP4sN","landscape":"tB1ef","portrait":"gVeX3"};